import { useState, useEffect, useRef } from "react";
import { Notification } from "@rio-cloud/rio-uikit";
import { getBranch, createBranches } from "../services";

export function useDashboardOnboarding() {
  const [numFiliais, setNumFiliais] = useState(1);
  const [onboardingStep, setOnboardingStep] = useState(1);
  const [hasFiliaisCadastradas, setHasFiliaisCadastradas] = useState(false);
  const [filiaisNames, setFiliaisNames] = useState<string[]>(["Matriz", "", ""]);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [forceClose, setForceClose] = useState(false);

  useEffect(() => {
    let isMounted = true;

    setIsLoading(true);

    const fetchBranches = async () => {
      try {
        const branches = await getBranch();
        if (!isMounted) {
          return;
        }

        setHasFiliaisCadastradas(branches.length > 0);
      } catch {
        if (!isMounted) {
          return;
        }

        setHasFiliaisCadastradas(false);
      } finally {
        if (!isMounted) {
          return;
        }

        setIsLoading(false);
      }
    };

    fetchBranches();

    return () => {
      isMounted = false;
    };
  }, []);

  const showOnboarding = !hasFiliaisCadastradas && !forceClose;
  const prevNumFiliaisRef = useRef(numFiliais);

  const handleCloseOnboarding = () => {
    setForceClose(true);
  };

  const resetOnboarding = () => {
    setForceClose(false);
    // setOnboardingStep(1);
  };

  const handleNextStep = async () => {
    if (onboardingStep < 3) {
      setOnboardingStep(onboardingStep + 1);
    } else {
      // Salvar filiais antes de fechar o onboarding
      setIsSaving(true);
      try {
        const branchesToCreate = filiaisNames
          .slice(0, numFiliais)
          .filter((name) => name.trim() !== "")
          .map((name) => ({ name: name.trim() }));

        await createBranches(branchesToCreate);

        setHasFiliaisCadastradas(true);
        handleCloseOnboarding();
      } catch (error) {
        console.error("Erro ao salvar filiais:", error);
        Notification.error("Não foi possível salvar as filiais. Tente novamente.");
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handlePrevStep = () => {
    if (onboardingStep > 1) {
      setOnboardingStep(onboardingStep - 1);
    }
  };

  const handleFilialNameChange = (index: number, value: string) => {
    const newNames = [...filiaisNames];
    newNames[index] = value;
    setFiliaisNames(newNames);
  };

  const handleNumFiliaisChange = (num: number) => {
    const prevNum = prevNumFiliaisRef.current;
    setNumFiliais(num);
    setFiliaisNames((prev) => {
      let newNames = prev.slice(0, num);
      if (newNames.length < num) {
        newNames = [...newNames, ...Array(num - newNames.length).fill("")];
      }

      if (num === 1) {
        newNames[0] = "Matriz";
      } else if (prevNum === 1 && prev[0]?.trim() === "Matriz" && newNames[0]?.trim() === "Matriz") {
        newNames[0] = "";
      }

      return newNames;
    });
    prevNumFiliaisRef.current = num;
  };

  return {
    showOnboarding,
    onboardingStep,
    onboarding: { numFiliais, filiaisNames },
    handleCloseOnboarding,
    handleNextStep,
    handlePrevStep,
    handleFilialNameChange,
    handleNumFiliaisChange,
    closeOnboarding: handleCloseOnboarding,
    resetOnboarding,
    onboardingLoading: isLoading,
    onboardingSaving: isSaving,
  };
}
